import { MinimumOrderValue } from '../common/state/state';
import MinimumOrderValueChip from '../common/components/MinimumOrderValueChip';
import DeliveryTimeChip from '../common/components/DeliveryTimeChip';
import { GeoLoc } from '../common/models/user.models';
import CompanyCategoryTag from './CompanyCategoryTag';

export interface InfoSocialTagsProps {
  isWholesaler?: boolean;
  minimumOrderValue?: MinimumOrderValue;
  deliveryTime?: number;
  targetGeoLoc?: GeoLoc;
}

export default function InfoSocialTags({ isWholesaler, minimumOrderValue, deliveryTime, targetGeoLoc }: InfoSocialTagsProps): React.JSX.Element {
  return (
    <>
      <MinimumOrderValueChip
        variant="outlinedTag"
        minimumOrderValue={minimumOrderValue?.value}
        minimumOrderValueType={minimumOrderValue?.type}
        negotiable={minimumOrderValue?.negotiable}
      />
      {deliveryTime && <DeliveryTimeChip deliveryTime={deliveryTime} variant="outlinedTag" />}
      {targetGeoLoc && <CompanyCategoryTag targetGeoLoc={targetGeoLoc} isWholesaler={isWholesaler} />}
    </>
  );
}
